(function () {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  function initMegaMenu(menu) {
    if (!menu || menu.dataset.picuraBalanceInitialized === '1') return;
    menu.dataset.picuraBalanceInitialized = '1';

    const grid = menu.querySelector('.picura-mm__grid');
    if (!grid) return;

    let cols = Array.from(grid.querySelectorAll(':scope > .picura-mm__col'));
    if (!cols.length) return;

    if (!grid.dataset.picuraStored) {
      grid.dataset.picuraStored = '1';
      cols.forEach((col, i) => {
        col.dataset.originalIndex = String(i);
        col.dataset.originalHtml = col.innerHTML;
      });
    }

    function ensureBackup() {
      if (!grid._picuraBackup) {
        const all = Array.from(grid.querySelectorAll(':scope > .picura-mm__col'));
        grid._picuraBackup = [];
        all.forEach((col, i) => {
          const idx = Number(col.dataset.originalIndex || i);
          grid._picuraBackup[idx] = col.dataset.originalHtml || col.innerHTML;
        });
      }
    }

    function restoreOriginal() {
      if (!grid._picuraBackup) return;

      grid.innerHTML = '';

      grid._picuraBackup.forEach((html, i) => {
        const col = document.createElement('div');
        col.className = 'picura-mm__col';
        col.dataset.originalIndex = String(i);
        col.dataset.originalHtml = html;
        col.innerHTML = html;
        grid.appendChild(col);
      });

      cols = Array.from(grid.querySelectorAll(':scope > .picura-mm__col'));
    }

    function wrapBaseAsSection(col) {
      if (col.querySelector(':scope > .picura-mm__section')) return;

      const count = col.querySelectorAll('.picura-mm__item').length;
      const html = col.innerHTML;
      col.innerHTML = `<div class="picura-mm__section" data-count="${count}">${html}</div>`;
    }

    function score(col) {
      const sections = Array.from(col.querySelectorAll('.picura-mm__section'));

      if (!sections.length) {
        return col.querySelectorAll('.picura-mm__item').length;
      }

      return sections.reduce((sum, sec) => sum + Number(sec.dataset.count || 0), 0);
    }

    function rebuild() {
      ensureBackup();
      restoreOriginal();

      const computed = getComputedStyle(grid);
      const maxCols = parseInt(computed.getPropertyValue('--picura-mm-cols')) || 5;

      cols = Array.from(grid.querySelectorAll(':scope > .picura-mm__col'))
        .sort((a, b) => Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex));

      if (cols.length <= maxCols) return;

      const base = cols.slice(0, maxCols);
      const extras = cols.slice(maxCols);

      base.forEach((col) => {
        col.classList.add('picura-mm__col--stacked');
        wrapBaseAsSection(col);
      });

      extras.forEach((extra) => {
        const count = extra.querySelectorAll('.picura-mm__item').length;
        const html = extra.innerHTML;

        let target = base[0];
        let min = score(target);

        for (const b of base) {
          const s = score(b);
          if (s < min) {
            min = s;
            target = b;
          }
        }

        const sec = document.createElement('div');
        sec.className = 'picura-mm__section';
        sec.dataset.count = String(count);
        sec.innerHTML = html;

        target.appendChild(sec);
        extra.remove();
      });
    }

    const debouncedRebuild = debounce(rebuild, 150);

    rebuild();
    window.addEventListener('resize', debouncedRebuild);
  }

  window.picuraInitMegaMenuBalance = function (root) {
    const scope = root || document;
    scope.querySelectorAll('.picura-mm').forEach(initMegaMenu);
  };

  document.addEventListener('DOMContentLoaded', function () {
    window.picuraInitMegaMenuBalance(document);
  });

  document.addEventListener('picura:mega-menu-loaded', function (event) {
    window.picuraInitMegaMenuBalance(event.detail && event.detail.item ? event.detail.item : document);
  });
})();